<template>
    <div class="container mt-nav z-index">
        <Head title="مراحل رسیدن شما به وزن ایده آل در بادوم" />
        <div class="row">
            <div class="col-sm-10 col-lg-7  mx-auto">
                <div class="bg__slider">
                    <div id="carouselExampleCaptions" class="carousel slide " data-bs-ride="carousel">
                        <div class="carousel-indicators d-flex align-content-center justify-content-between">
                            <span class="m-0 text-md" id="prev">مرحله بعد</span>
                            <div>
                                <button v-for="(step , i) in stepBar" type="button" data-bs-target="#carouselExampleCaptions" :data-bs-slide-to="i"
                                        :class="{'active' : i === 0}" :aria-current="{'true' : i === 0}" aria-label="Slide {{i+1}}"></button>

                            </div>
                            <span class="m-0 text-md" id="next">مرحله قبل</span>
                        </div>
                        <div class="carousel-inner">
                            <template v-for="(step , i) in stepBar">
                                <div class="carousel-item  " :class="i === 0 ? 'active' : ''">
                                    <div class="d-flex align-content-center justify-content-center">
                                        <img :src="step.image" alt="">
                                    </div>
                                    <div class="carousel-caption">
                                        <h5 v-text="step.title"></h5>
                                        <p class="m-0 line-height text-dark-gray mt-4"  v-text="step.description"> </p>
                                    </div>
                                </div>
                            </template>
                        </div>

                    </div>
                    <div class="mt-5 text-center">
                        <Link class="btn btn-orange w-100-btn"  href="/packages">ادامه مراحل و دریافت رژیم</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {Head, Link} from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "..//Shared/Layouts/LayoutFirstRegister";

export default {
    props : ['name' , 'stepBar'],
    components: {
        Head, Link
    },

    layout: LayoutFirstRegister,
    metaInfo() {
        return {
            meta : [
            ]
        }

    },
    created() {
        this.stepBar.forEach((item) => {
            console.log('info', item);

        })
    }
}
</script>

<style scoped>

</style>
